import { Injectable } from "@angular/core";
import { ContextExtractor } from "projects/borrower-app/src/app/services/context-extractor";
import { UtilsService } from "projects/borrower-app/src/app/services/utils.service";
import { WizardFlowContext } from "../../../wizard-flow-context.model";
import { AddressStep } from "../../address-step.model";
import { WizardStepBase } from "../../wizard-step-base.model";
import { AddressStepConfig } from "../address-step-config.model";
import { FieldConfigUtils } from "../field-config-utils";
import { StepConfig } from "../step-config.model";
import { NextStepDeciderFactory } from "./next-step-decider.factory";
import { StepFactoryBase } from "./step-factory-base";
import { ICreateStep } from "./step-factory.interface";

@Injectable()
export class AddressStepFactory extends StepFactoryBase<AddressStepConfig> implements ICreateStep {

  create(config: AddressStepConfig, wizardFlowContext: WizardFlowContext): WizardStepBase {
    const nextStepDecider = this._nextStepDeciderFactory.create(config.nextStepDeciderConfig, wizardFlowContext);
    const model = ContextExtractor.extractContext(wizardFlowContext, config.contextType);
    const addressStep = new AddressStep(config.id, config.name, config.path, nextStepDecider, config.addressFields, model);
    addressStep.title = config.title;
    addressStep.explanation = config.explanation;
    addressStep.heading = config.heading;
    addressStep._i18n = config._i18n;
    // Merge default field config with persisted overrides (same pattern as GenericStepFactory).
    // Backward-compat: existing flow JSON without a fieldConfig blob picks up the defaults
    // (all entries default isHidden=true, isRequired=false → no visible change for borrowers).
    const defaultFieldConfig = FieldConfigUtils.generateDefaultFieldConfigForStep(config.stepType);
    const fieldConfig: any = config.fieldConfig && Object.keys(config.fieldConfig).length ? { ...config.fieldConfig } : {};
    for (const key of Object.keys(defaultFieldConfig)) {
      if (!(key in fieldConfig)) {
        fieldConfig[key] = defaultFieldConfig[key];
      }
    }
    for (const key of Object.keys(fieldConfig)) {
      if (!(key in defaultFieldConfig)) {
        delete fieldConfig[key];
      }
    }
    config.fieldConfig = fieldConfig;
    addressStep.fieldConfig = fieldConfig;
    return addressStep;
  }

  configure(step: WizardStepBase, config: StepConfig): void {
    config.explanation = step.explanation;
    config.title = step.title;
    config.heading = step.heading;
    config.groupId = step.groupId;
    config._i18n = step._i18n;
    config.fieldConfig = step.fieldConfig;
  }

  constructor(private readonly _nextStepDeciderFactory: NextStepDeciderFactory,
    private readonly _utilsService: UtilsService) {
      super();
  }
}
